"use strict"

import * as App from '../app/app~fv=cw_byBD8.min.js';
import '../pkg/urlform~fv=VhWyOSvq.min.js'; // Namespaced as 'URLForm'.

/**
@typedef {import ('../pkg/urlformjs/urlform.js').FormParameters} FormParameters
@typedef {import ('../pkg/urlformjs/urlform.js').FormOptions}    FormOptions
*/

/**@type {FormOptions}*/
const FormOptions = {
	"id": "buyMore",
	/**@type {FormParameters}*/
	"FormParameters": [{
			"name": "id",
		},
		{
			"name": "first_name",
		},
		{
			"name": "last_name",
		},
		{
			"name": "organization",
		},
		{
			"name": "email",
		},
		{
			"name": "number_of_labels",
			"type": "number"
		},
		{
			"name": "label_size"
		},
		{
			"name": "additional_info"
		},
	],
}

// All required fields in the buy form. Fields not specified are optional.
const required = ["first_name", "last_name", "email"]

App.AddOnload(BuyOnLoad)

/**
BuyOnLoad sets up the buy page on page load.
@returns {void} 
*/
async function BuyOnLoad() {
	let initedFormOptions = URLForm.Init(FormOptions)

	document.getElementById('submitBuyForm').addEventListener('click', async () => {
		let form = URLForm.GetForm(initedFormOptions)
		// console.debug(form)

		// Check that all required fields exist
		for (let field of required) {
			if (!(field in form)) {
				let err = `Field ${field} is required.`
				console.debug(err)
				App.Error(err)
			}
		}

		if (!validateEmail(form.email)) {
			App.Error(`Email is not a valid address ${form.email}`)
		}

		// Submit email
		let formData = new(FormData)
		formData.append('pr', JSON.stringify(form))
		formData.append('email', "buy@cyphr.me")
		let rjson = await App.FetchPost(App.API.Post.PurchaseOrder, formData)
		// console.debug(rjson)
		if (!rjson.success) {
			App.Error("Submitting the order failed. Please try again, or email buy@cyphr.me .")
		}
		// Default server msg from email endpoints is: Email sent successfully.
		// Check your inbox. This particular endpoint is sent to a cyphr.me email,
		// so users do not have an email in their inbox. Use custom success msg.
		App.Notification("Your purchase request was received.", "success")
	})
}

/**
validateEmail returns whether the given email valid format. Solution from:
https://stackoverflow.com/questions/46155/how-can-i-validate-an-email-address-in-javascript

TODO maybe move to helpers or app?
@param   {string}  email
@returns {boolean}
*/
function validateEmail(email) {
	if (typeof email !== "string") {
		return false
	}
	let re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/ // Prevents matching multiple @ signs.
	let matches = email.toLowerCase().match(re)
	if (isEmpty(matches)) {
		return false
	}
	return matches.includes(email)
}